import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Axios from "axios";

import Paypal from "../../../../utils/Paypal/Paypal";
import { url } from "../../../../config/config";
import { connect } from "react-redux";
import JwtDecode from "jwt-decode";
import ErrorDialog from "../../../../Component/ErrorDialog/ErrorDialog";
import { useStyles } from "./RentDialogBox.css";

class RentDialogBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        orderId: sessionStorage.getItem("orderId"),
        bookCoverUrl: this.props.book.bookCoverUrl,
        bookId: this.props.book._id,
        title: this.props.book.title,
        author:
          this.props.book.author.firstName +
          " " +
          this.props.book.author.lastName,
        price: this.props.book.price,
      },
      userData: [],
      errorStatus: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    this.decodeToken(this.props.userToken);
  }

  decodeToken = (userToken) => {
    try {
      const decodedData = JwtDecode(userToken);
      this.setState({
        userData: decodedData,
      });
    } catch (err) {}
  };

  transactionSuccess = async (paymentData) => {
    try {
      let data = {
        orderId: this.state.data.orderId,
        payVia: this.props.payType,
        paypalEmail: paymentData.email,
        paymentId: paymentData.paymentID,
        rentedDays: parseInt(this.props.rentedDays),
        totalPrice: this.props.totalPrice,
        bookId: this.state.data.bookId,
      };
      const response = await Axios.post(`${url}/api/rent`, data, {
        headers: {
          "x-auth-token": this.props.userToken,
        },
      });
      if (response.data.success) {
        this.props.history.push(`/myrentedbooks`);
      }
    } catch (error) {
      if (error.response.data.errorMessage) {
        this.setState({
          errorStatus: true,
          errorMessage: error.response.data.errorMessage,
        });
      }
    }
  };

  transactionError = () => {
    console.log("Paypal error");
  };

  transactionCanceled = () => {
    console.log("Transaction canceled");
  };

  render() {
    const { classes, payType } = this.props;
    const { data } = this.state;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        style={{ fontFamily: "Open Sans", fontSize: 20 }}
      >
        {this.state.errorStatus === true && (
          <ErrorDialog
            message={this.state.errorMessage}
            url={`/book/rent/${data.bookId}`}
          />
        )}
        <DialogTitle>OrderId: {data.orderId}</DialogTitle>
        <DialogContent className={classes.contentStyle}>
          <img
            src={data.bookCoverUrl}
            alt="bookCover"
            className={classes.coverImageStyle}
          />
          <h2>{data.title}</h2>
          <p>Rent for {this.props.rentedDays} days</p>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              flexDirection: "column",
            }}
          >
            {payType === "esewa" ? (
              <b>Total Price: Rs.{this.props.totalPrice}</b>
            ) : (
              <b>Total Price: ${this.props.changedCurrency}</b>
            )}
            <p>By {data.author}</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disableRipple
            className={classes.cancelButtonStyle}
            onClick={this.props.handleClose}
          >
            Cancel
          </Button>
          {this.props.payType === "esewa" ? (
            <Button
              variant="contained"
              disableRipple
              className={classes.payButtonStyle}
            >
              pay
            </Button>
          ) : (
            this.props.changedCurrency > 0 && (
              <Paypal
                totalPrice={this.props.changedCurrency}
                onSuccess={this.transactionSuccess}
                transactionError={this.transactionError}
                transactionCanceled={this.transactionCanceled}
              />
            )
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(RentDialogBox)));
